import styled from "styled-components";

export const ClockWrapper = styled.div`
  position: absolute;
  top: -40px;
  right: 0;
  font-size: 14px;
  font-family: monospace;
  color: #000;
  background: none;
  padding: 0;
  margin: 0;
`;
